// Runtime-first config.
//
// These values are read at RUNTIME from `window.__ENV__`, which `server.js`
// injects into index.html from the app's Heroku config vars on every request.
// They take precedence over the build-time `process.env` values baked by
// dotenv-webpack.
//
// Why: the URLs used to be baked into the bundle at build time. Combined with
// the Heroku pipeline (promote copies the *compiled slug* of the staging app),
// a promote carried the staging-built bundle — with `api.stagecliengo.com`
// hardcoded — to production, breaking the access gate (`/users/me` hit stage,
// prod JWTs got 401 → everyone non-superadmin got `forbidden`). Resolving at
// runtime makes a single slug correct in any environment, so promotes are safe.
// The `process.env` values remain a fallback for local dev (`.env`).

type RuntimeEnvKey =
  | 'APP_NAME'
  | 'LOGIN_URL'
  | 'HSM_BACKEND_URL'
  | 'CLIENGO_API_URL';

declare global {
  interface Window {
    __ENV__?: Partial<Record<RuntimeEnvKey, string>>;
  }
}

const runtime: Partial<Record<RuntimeEnvKey, string>> =
  (typeof window !== 'undefined' && window.__ENV__) || {};

export const APP_NAME: string =
  runtime.APP_NAME || process.env.APP_NAME || 'new-hsm-admin';

export const LOGIN_URL: string =
  runtime.LOGIN_URL ||
  process.env.LOGIN_URL ||
  'https://www.login.stagecliengo.com';

export const HSM_BACKEND_URL: string =
  runtime.HSM_BACKEND_URL ||
  process.env.HSM_BACKEND_URL ||
  'https://hsm-backend.stagecliengo.com';

// Cliengo API base. Used to resolve the caller (GET /1.0/users/me) in the
// access gate — the JWT does not carry the email. Default targets stage (like
// the other vars); prod sets CLIENGO_API_URL=https://api.cliengo.com as a
// config var, injected at runtime by server.js.
export const CLIENGO_API_URL: string =
  runtime.CLIENGO_API_URL ||
  process.env.CLIENGO_API_URL ||
  'https://api.stagecliengo.com';
